import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function RecordStatus(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            id="recordStatus_a"
            onChange={(_event, newValue) => {
                props.HandleRecordStatusChange(newValue);
            }}
            value={props.recordStatusList.filter(item => item.code === props.recordStatus)[0]?.description ?? ""}
            defaultValue=""
            options={props.recordStatusList.map((option) => option.description)}
            renderInput={(params) => <TextField id="recordStatus_t" {...params} margin="normal" label={t("RecordStatus")} variant="outlined" />}
            size={props.size ?? "normal"}
        />
    );
}
